import type { FaireProductEntity } from "../../entity_types/product";

export const p_9wcjpo533c: FaireProductEntity = {
  token: "p_9wcjpo533c",
  type: "product",
  name: "Sagebrush — Regenerative Organic Certified",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/a59bc2c4a7aeec9186dad5cd88dcd5f886256c5ceebef66f7c40a5ef0d68c7d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/76b5a57e05b7bd916673a6696434d5c940fa53562d62c347c1b443c697edb159.jpeg",
    "https://cdn.faire.com/fastly/3a2ab15ddc03a92f2fc007c29e6711bec02ffb2087c0c7c22c6710af0fc20d2a.jpeg",
    "https://cdn.faire.com/fastly/14c443f849f6789bb581ddbddd00404c66562af836caa00105b41db64a0da7b6.jpeg",
  ],
  priceDollars: 13.5,
  description:
    "Sagebrush is crafted to be the perfect daily cup of drip coffee — the kind we want to enjoy, black or with milk, every morning. We source Sagebrush from new and emerging farmers and co-ops making efforts to improve their ecological sustainability and economic well-being of workers.",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:10.480Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
